<template>
  <div class="pageStyle">
    <div class="rightBg">
      <div class="rightBg-box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="title">
      <div>您好！</div>
      <div>{{ signTitle }}期待您的注册</div>
    </div>
    <div class="content">
      <div class="input">
        <div class="item">
          <span class="item-title">姓名</span>
          <van-field v-model="form.name" placeholder="请输入您的姓名" />
        </div>
        <div class="item">
          <span class="item-title">手机号</span>
          <van-field
            type="digit"
            v-model="form.phone"
            placeholder="请输入您的手机号"
          />
        </div>
        <div class="item code">
          <span class="item-title">验证码</span>
          <van-field
            maxlength="6"
            v-model="form.code"
            placeholder="请输入验证码"
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                color="#0b6ff9"
                @click="toGetCode"
                >{{ codeTxt }}</van-button
              >
            </template>
          </van-field>
        </div>
      </div>
      <div class="fun">
        <span class="blueColor" @click="toPage('')">返回首页</span>
        <span
          >已有账号？<s class="blueColor" @click="toPage('login')">去登陆</s>
        </span>
      </div>
      <div class="btn">
        <span @click="toSubmit">注册</span>
      </div>
      <!-- <div class="check">
        <van-checkbox
          icon-size="4vw"
          v-model="form.checked"
          shape="square"
          checked-color="#0b6ff9"
          >我已阅读并同意<span> 隐私政策 </span>和<span> 注册协议</span>
        </van-checkbox>
      </div> -->
    </div>
    <van-dialog
      title="注册成功"
      v-model="signSuccessDialogShow"
      confirmButtonText="确认"
      @confirm="signSuccessDialogConfirm"
    >
      <div class="signSuccessDialogShow">
        <van-icon name="passed" size="16vw" color="#07c160" />
        <div class="txt">
          <span>初始密码：123456</span
          ><span>*请牢记您的初始密码，确认后将自动登录</span>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { xcChannelSign, sendSms, smsValid } from "@/api/login.js";
import { getDivision } from "@/utils/wxJsSdk.js";
import { setToken } from "@/utils/auth.js";
import { mapGetters } from "vuex";
import { updateChannelToken } from "@/api/login.js";
import { xcDepConfig } from "@/api/depConfig.js";
import store from "@/store";
//导入getWxUserInfo
import { getWxUserInfo, getDepNameByDomain } from "@/utils/index.js";
import Vue from "vue";
import {
  Tab,
  Tabs,
  Field,
  Checkbox,
  Button,
  Notify,
  Toast,
  Dialog,
  Icon,
} from "vant";
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(Button);
Vue.use(Icon);
export default {
  computed: {
    ...mapGetters(["Login"]),
  },
  data() {
    return {
      active: 0,
      form: {
        phone: "",
        username: "",
        code: "",
        name: "",
        checked: true,
        openId: "",
        headImgUrl: "",
        nickName: "",
        depName: "",
        parentId: "",
      },
      signTitle: "",
      codeTxt: "发送验证码",
      getCodeFlag: false,
      signSuccessDialogShow: false,
      signRes: "",
      redirectUrl: this.$route.query.redirectUrl,
    };
  },

  mounted() {
    this.getQuery();
    getDivision().then((res) => {
      console.log("getwx :>> ", res);
    });
  },

  methods: {
    getQuery() {
      this.form.parentId = this.getQueryString("parentId");
      this.form.depName = getDepNameByDomain();
      xcDepConfig(this.form.depName).then((res) => {
        this.signTitle = res.depTitle;
      });
      let wxUserInfo = getWxUserInfo();
      if (wxUserInfo) {
        this.form.headImgUrl = wxUserInfo.headimgurl;
        this.form.nickName = wxUserInfo.nickname;
        this.form.openId = wxUserInfo.openid;
      }
      console.log("wxUserInfo :>> ", wxUserInfo);
    },
    toGetCode() {
      // 防止频繁点击
      if (this.getCodeFlag) return false;
      if (!this.form.phone) {
        Notify({ type: "danger", message: "请输入您的手机号" });
        return false;
      }
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      sendSms(this.form.phone)
        .then((res) => {
          Toast.clear();
          Notify({
            type: "success",
            message: "验证码已发送，请留意您的手机短信",
          });
          this.phoneCodeInterval();
        })
        .catch((err) => {
          Toast.clear();
          Notify({ type: "danger", message: "验证码发送失败" });
        });
    },
    phoneCodeInterval() {
      let time = 60;
      this.getCodeFlag = true;
      let v = setInterval(() => {
        time = time - 1;
        this.codeTxt = time + " s " + "重新获取";
        if (time == 0) {
          clearInterval(v);
          this.getCodeFlag = false;
          this.codeTxt = "获取验证码";
        }
      }, 1000);
    },
    toSubmit() {
      if (this.toVerify()) {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0,
        });
        // 验证验证码
        smsValid(this.form.phone, this.form.code)
          .then((res) => {
            if (res.token) {
              xcChannelSign(this.form, res.token)
                .then((res) => {
                  Toast.clear();
                  this.signRes = res;
                  this.signSuccessDialogShow = true;
                  // Notify({
                  //   message: "注册成功，请等待页面自动跳转...",
                  //   duration: 5000,
                  //   type: "success",
                  // });
                  // // 自动跳转登录 调用登陆方法
                  // this.toLogin(res);
                })
                .catch((err) => {
                  Toast.clear();
                  console.log("err", err);
                });
            } else {
              Toast.clear();
              Notify({ type: "danger", message: "验证码错误" });
            }
          })
          .catch((err) => {
            Toast.clear();
          });
      }
    },
    // 注册成功弹窗 点击确认
    signSuccessDialogConfirm() {
      this.toLogin(this.signRes);
    },
    toLogin(res) {
      Toast.clear();
      setToken(res.token);
      this.setChannelToken(res.token);
      store.dispatch("Login", res.user);
      Notify({ type: "success", message: "登录成功" });
      // 判断是否有回调地址
      if (this.redirectUrl) {
        this.$router.push({
          path: "/",
          query: { redirectUrl: this.redirectUrl },
        });
      } else {
        // 没有回调地址,跳转首页
        this.$router.push({ path: "/" });
      }
    },

    toPage(name) {
      if (name === "login") {
        // 判断是否携带注册后的回调地址参数
        if (this.redirectUrl) {
          this.$router.push({
            path: "/login",
            query: { redirectUrl: this.redirectUrl },
          });
        } else {
          this.$router.push({ path: "/login" });
        }
      } else {
        this.$router.push({ path: "/" + name });
      }
    },
    toVerify() {
      if (!this.form.name) {
        Notify({ type: "danger", message: "请输入您的姓名" });
        return false;
      }
      if (!this.form.phone) {
        Notify({ type: "danger", message: "请输入您的手机号" });
        return false;
      }
      if (!this.form.code) {
        Notify({ type: "danger", message: "请输入短信验证码" });
        return false;
      }
      if (!this.form.checked) {
        Notify({ type: "danger", message: "请仔细阅读用户协议后点击勾选" });
        return false;
      }
      return true;
    },
    // 设置渠道的token
    setChannelToken(token) {
      let body = {
        token: token,
      };
      updateChannelToken(body).then((res) => {
        console.log("res", res);
      });
    },
    getQueryString(name) {
      let query = window.location.href.split("?")[1];
      if (query) {
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == name) {
            return pair[1];
          }
        }
      }
      return null;
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/sign/index.vue